<template>
<div id="gift-box-payment" :class="isPhone ? 'gift-box-payment-phone' : ''">
  <ModalGiftBoxUpdate v-if="activeUpdateModalId" :key="`modal-update-item`" :update-mode="true" :purchase-item="getActiveUpdateItem()" @update="updateCartItem($event)" @remove="removeFromCart($event)" @close="activeUpdateModalId = null"/>
  <ModalGiftBoxUpdate v-if="activeAddModalId" key="modal-add" :update-mode="false" :purchase-item="getActiveAddItem()" @add="addToCart($event)" @close="activeAddModalId = null"/>
  <div class="container-gift-box pb-5" v-if="!bookingConfirmed">
    <div class="row row-gift-box">
      <div class="col-12 col-md-7 order-2 order-md-1 col-info-left">
        <div class="d-flex flex-column justify-content-center align-items-start w-100">
          <div class="d-flex justify-content-start align-items-start mb-4" v-if="!isPhone" @click="close()">
            <div class="back-button d-flex align-items-center">
              <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 23px; height: 17.5px;" />
            </div>
          </div>
          <div class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 mt-4 gift-boxes-section" :class="currentStep !== 1 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18 d-flex justify-content-between w-100">
              <span>1. Nos coffrets cadeaux</span>
              <span v-if="currentStep !== 1" class="link-text raleway-medi-p13" @click="currentStep = 1">Modifier</span>
            </div>
            <div class="w-100 position-relative" v-if="currentStep == 1">
              <div id="scroller" :class="isPhone ? 'd-flex align-items-start justify-content-start w-100 overflow-auto' : 'w-100'" style="gap: 10px;">
                <div class="card-gift-box-item w-100" v-for="(giftBox, index) in giftBoxItems" :key="index" style="margin-top: 20px;">
                  <GiftBoxItem v-if="!isPhone" :gift-box="giftBox" @add-to-cart="addToCart($event)" @remove-from-cart="removeFromCart($event)" />
                  <div class="border-bottom-gray mt-4 mx-5" v-if="index != giftBoxes.length - 1 && !isPhone"></div>
                  <div v-if="isPhone">
                    <div class="d-flex flex-column align-items-start justify-content-start">
                      <div class="gift-box-img">
                        <img :src="giftBox.photo_key" alt="">
                      </div>
                      <div class="merriweather-reg-13 pt-2">{{ giftBox.name }}</div>
                      <div class="raleway-light-13" v-html="giftBox.description"></div>
                      <div class="hortense-btn-primary" @click="activeAddModalId = giftBox.id">
                        AJOUTER AU PANIER
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0 previous-slide-button circle-icon" v-if="isPhone && giftBoxItems.length > 2" @click="scroll_left">
                <img src="../../images/arrow-left-black.svg" alt="Previous" />
              </div>
              <div class="flex-shrink-0 next-slide-button circle-icon" v-if="isPhone && giftBoxItems.length > 2" @click="scroll_right">
                <img src="../../images/arrow-right-black.svg" alt="Next" />
              </div>
            </div>
            <div v-if="currentStep == 1" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
              <div class="hortense-btn-primary" @click="changeStep(2)">
                PASSEZ À L’ÉTAPE SUIVANTE
              </div>
            </div>
          </div>
          <div id="step-2" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 information-section" :class="currentStep !== 2 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              2. Informations
            </div>
            <div class="w-100" v-if="currentStep == 2">
              <div class="d-flex flex-column align-items-center my-4" style="gap: 10px;">
                <div class="d-flex align-items-start gap-2" style="width: 350px;">
                  <input
                    type="checkbox"
                    id="personal"
                    :checked="giftBoxPurchase.purchase_type === 'personal'"
                    @change="togglePurchaseType('personal')"
                    class="mt-1"
                  />
                  <label for="personal" class="raleway-reg-p15 mb-0">
                    <span class="ml-2 text-nowrap">Je m’offre une évasion éco-chic</span>
                  </label>
                </div>

                <div class="d-flex align-items-start gap-2" style="width: 350px;">
                  <input
                    type="checkbox"
                    id="entreprise"
                    :checked="giftBoxPurchase.purchase_type === 'entreprise'"
                    @change="togglePurchaseType('entreprise')"
                    class="mt-1"
                  />
                  <label for="entreprise" class="raleway-reg-p15 mb-0">
                    <span class="ml-2 text-nowrap">J’achète pour le compte d’une entreprise</span>
                  </label>
                </div>
              </div>
              <div v-if="giftBoxPurchase.purchase_type === 'beneficiary'">
                <p class="raleway-semi-p15">À l’attention de</p>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Nom*
                    <input v-model="giftBoxPurchase.owner.last_name" :disabled="user ? true : false" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-6">
                    Prénom*
                    <input v-model="giftBoxPurchase.owner.first_name" :disabled="user ? true : false" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email*
                    <input v-model="giftBoxPurchase.owner.email" :disabled="user ? true : false" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Adresse
                    <input v-model="giftBoxPurchase.owner.address" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Code postal
                    <input v-model="giftBoxPurchase.owner.postal_code" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Ville
                    <input v-model="giftBoxPurchase.owner.city" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Pays
                    <input v-model="giftBoxPurchase.owner.country" type="text" />
                  </label>
                </div>
                <p class="raleway-light-italic-13 light-gray-text">(Merci de renseigner l’adresse, le code postal et la ville pour l’envoi du coffret physique).</p>
                <p class="raleway-semi-p15 pt-3">De la part de</p>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Nom*
                    <input v-model="giftBoxPurchase.receiver.last_name" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-6">
                    Prénom*
                    <input v-model="giftBoxPurchase.receiver.first_name" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Email*
                    <input v-model="giftBoxPurchase.receiver.email" type="text" />
                  </label>
                </div>
                <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
              </div>
              <div v-if="giftBoxPurchase.purchase_type === 'personal'">
                <div class="col-12">
                  <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Nom*
                    <input v-model="giftBoxPurchase.owner.last_name" :disabled="user ? true : false" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-6">
                    Prénom*
                    <input v-model="giftBoxPurchase.owner.first_name" :disabled="user ? true : false" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email*
                    <input v-model="giftBoxPurchase.owner.email" :disabled="user ? true : false" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Adresse*
                    <input v-model="giftBoxPurchase.owner.address" type="text" />
                  </label>
                </div>
                <div class="line-form row mb-2">
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Code postal *
                    <input v-model="giftBoxPurchase.owner.postal_code" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Ville *
                    <input v-model="giftBoxPurchase.owner.city" type="text" />
                  </label>
                  <label for="name" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Pays *
                    <input v-model="giftBoxPurchase.owner.country" type="text" />
                  </label>
                </div>
                <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
                </div>
              </div>
              <div v-if="giftBoxPurchase.purchase_type === 'entreprise'" class="col-12">
                <div class="line-form row mb-2">
                  <label for="company_name" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Nom de la société *
                    <input v-model="giftBoxPurchase.owner.company_name" type="text" id="company_name" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="vat_number" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    N° de TVA *
                    <input v-model="giftBoxPurchase.owner.vat_number" type="text" id="vat_number" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="last_name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                    Nom *
                    <input v-model="giftBoxPurchase.owner.last_name" :disabled="user ? true : false" type="text" id="last_name" />
                  </label>

                  <label for="first_name" class="col-12 col-md-6">
                    Prénom *
                    <input v-model="giftBoxPurchase.owner.first_name" :disabled="user ? true : false" type="text" id="first_name" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="phone" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Numéro de téléphone *
                    <input v-model="giftBoxPurchase.owner.phone" type="text" id="phone" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="email" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Email professionnel *
                    <input v-model="giftBoxPurchase.owner.email" :disabled="user ? true : false" type="text" id="email" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="address" class="col-12 col-md-12" :class="isPhone ? '' : 'pr-4'">
                    Adresse *
                    <input v-model="giftBoxPurchase.owner.address" type="text" id="address" />
                  </label>
                </div>

                <div class="line-form row mb-2">
                  <label for="postal_code" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Code postal *
                    <input v-model="giftBoxPurchase.owner.postal_code" type="text" id="postal_code" />
                  </label>

                  <label for="city" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Ville *
                    <input v-model="giftBoxPurchase.owner.city" type="text" id="city" />
                  </label>

                  <label for="country" class="col-12 col-md-4" :class="isPhone ? '' : 'pr-4'">
                    Pays *
                    <input v-model="giftBoxPurchase.owner.country" type="text" id="country" />
                  </label>
                </div>

                <p class="raleway-light-italic-13 light-gray-text">(* champs obligatoires)</p>
              </div>
              <div v-if="currentStep == 2" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
                <div class="hortense-btn-primary" @click="changeStep(3)">
                  PASSEZ À L’ÉTAPE SUIVANTE
                </div>
              </div>
            </div>
          </div>
          <div id="step-3" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 personalise-section" :class="currentStep !== 3 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              3. Personnalisation
            </div>
            <div class="w-100 pt-3" v-if="currentStep == 3">
              <p class="raleway-reg-p15">Vous avez la possibilité d’ajouter un message personnalisé, qui apparaîtra directement dans le coffret du bénéficiaire.</p>
              <textarea v-model="giftBoxPurchase.personal_message" placeholder="Votre Message" class="line-form form-text-area" name="personal_message"></textarea>
              <div class=" d-flex pt-3" :class="isPhone ? 'align-items-start' : 'align-items-center'">
                <img src="../../images/info.svg" v-set-alt />
                <p class="raleway-reg-p15 mb-0" :class="isPhone ? '' : 'ml-2'">Vous avez la possibilité de programmer l’envoi du coffret à une date ultérieure.</p>
              </div>
              <p class="raleway-semi-p15 mb-1 pt-3">
                VEUILLEZ INDIQUER LA DATE SOUHAITÉE.
              </p>
              <p class="raleway-reg-p15">Sans indication de votre part, le coffret sera envoyé immédiatement après la confirmation de l’achat.</p>
              <div class="d-flex flex-row justify-content-center align-items-center w-100 pt-3">
                <div class="d-flex justify-content-center align-items-center date-picker-container">
                  <div class="raleway-medi-p15 d-flex justify-content-center align-items-center" style="gap: 18px;">
                    <p class="mb-0">Date d’envoi du coffret</p>
                    <div class="calendar-container">
                      <span class="calendar-icon" @click="handleCalendarIconClick"></span>
                      <VueDatePicker
                        v-model="giftBoxPurchase.scheduled_date"
                        format="DD/MM/YYYY"
                        placeholder="JJ/MM/AAAA"
                        :no-calendar-icon="true"
                        class="calendar-input"
                        :locale="{lang: 'fr'}"
                        :noHeader="true"
                        color="#3B6152"
                      >
                      </VueDatePicker>  
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="customDeliveryDateItem" class="raleway-reg-p15 px-5 pt-4 text-center">Le <strong>coffret cadeau {{ customDeliveryDateItem.name }}</strong> est actuellement disponible en précommande uniquement. Les livraisons débuteront <strong>à partir du {{ customDeliveryDateItem.send_date }}</strong></div>
              <div v-if="currentStep == 3" class="d-flex flex-row justify-content-center align-items-center w-100 pt-5" :class="isPhone ? 'px-4' : ''">
                <div class="hortense-btn-primary" @click="changeStep(4)">
                  PASSEZ À L’ÉTAPE SUIVANTE
                </div>
              </div>
            </div>
          </div>
          <div  id="step-4" class="pt-4 d-flex flex-column justify-content-center align-items-start w-100 payment-section" :class="currentStep !== 4 ? 'border-bottom-gray pb-4' : ''">
            <div class="raleway-medi-p18">
              4. Paiement
            </div>
            <div class="section-payment w-100 pt-3" v-if="currentStep == 4">
              <div class="info-payment">
              </div>
              <div class="link-container d-flex flex-column">
                <p class="raleway-bold-p14 d-flex w-full justify-content-center mb-2 text-uppercase">{{ $t("payment") }}</p>
                <div class="d-flex align-items-center justify-content-center payment-icons">
                  <img style="height: 42px;" src="../../images/pay1-color.svg" v-set-alt>
                  <img style="height: 42px;"  src="../../images/pay2-color.svg" v-set-alt>
                  <img style="height: 42px;" src="../../images/pay3-color.svg" v-set-alt>
                </div>
              </div>
              <div class="card-stripe mb-3 pt-3" :class="isPhone ? 'row' : ''">
                <div class="raleway-bold-p16 text-uppercase pb-4" :class="isPhone ? 'd-flex justify-content-start w-100' : ''">
                  <p class="raleway-bold-p16 mb-0" :class="isPhone ? 'text-center w-100' : ''">Carte de crédit</p>
                </div>
                <div class="field">
                  <input type="text" placeholder="Nom/Prénom" v-model="cardDetails.holder" />
                </div>
                <div class="field">
                  <div id="card-number" placeholder="1234  1234  1234  1234" class="input empty"></div>
                </div>
                <div class="field">
                  <div id="card-expiry" placeholder="MM / AA" class="input empty"></div>
                </div>
                <div class="field">
                  <div id="card-cvc" placeholder="CVC" class="input empty"></div>
                </div>
                <div id="card-errors" role="alert" ref="errorsCard"></div>

                <div class="form-item raleway-reg-p12 pt-3">
                  <input
                      type="checkbox"
                      id="payment-accept"
                      value="payment-accept"
                      v-model="acceptConditions"
                  />
                  <label for="payment-accept">J’accepte les <a class="link-hortense" href="/conditions-generales-ventes-coffrets-cadeaux" target="_blank">conditions générales de ventes.</a></label>
                </div>
                <div class="d-flex pt-3" :class="isPhone ? 'w-100 px-4' : 'justify-content-center'">
                  <button class="hortense-btn-primary w-100" :disabled="isProcessingPayment" @click.prevent="handlePayment">
                    VALIDER MA COMMANDE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5 order-1 order-md-2" :class="!isPhone ? 'pt-5' : ''">
        <div class="d-flex justify-content-start align-items-start mb-5" v-if="isPhone" @click="close()">
          <div class="back-button d-flex align-items-center ml-1">
            <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
          </div>
        </div>
        <div class="raleway-reg-p18 pb-3 pt-3">Votre panier <span class="raleway-light-18">({{ purchasesCount }} coffret<span v-if="purchasesCount > 1">s</span>)</span></div>
          <div class="card-checkout-items" :class="isPhone ? 'row' : ''">
            <div class="purchase-items-container w-100" :class="giftBoxPurchase.gift_box_purchase_items.length === 0 ? 'empty-cart' : 'h-100'">
              <div class="d-flex flex-column h-100 w-100 justify-content-center align-items-center" v-if="giftBoxPurchase.gift_box_purchase_items.length === 0">
                <div class="raleway-reg-p15 text-center" style="opacity: 0.56;">Votre panier est vide.</div>
                <img src="../../images/empty_cart.png" alt="Panier vide" style="width: 98px; height: 98px;">
              </div>
              <div v-else>
                <div v-for="(item, index) in giftBoxPurchase.gift_box_purchase_items" :key="item.purchase_id">
                <div class="d-flex align-items-baseline">
                  <span class="text-nowrap text-green" :class="isPhone ? 'raleway-reg-p15 mr-2' : 'raleway-reg-p20 mr-3'">{{ item.quantity }} x</span>
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center">
                        <div :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">{{ item.name }}</div>
                        <div v-if="!isPhone" class="link-text raleway-medi-p15 pl-3" @click="activeUpdateModalId = item.id">Modifier</div>
                      </div>
                      <div class="text-green cursor-pointer" @click="removeFromCart(item.purchase_id)"><img src="../../images/trash_icon.svg" v-set-alt/></div>
                    </div>
                    <div class="d-flex justify-content-between"  :class="isPhone ? '' : 'pt-3'">
                      <div class="raleway-reg-p15">Carte cadeau</div>
                      <div class="d-flex align-items-center justify-content-end" style="gap: 5px;" v-if="promoDiscountAmount > 0">
                        <div class="raleway-reg-p15 mb-0 discounted-amount text-light-gray">
                          <s>{{ item.amount }}€</s>
                        </div>
                        <div class="raleway-reg-p15">
                            {{ item.amount - getPercentageAmount(item.amount, discountPercentage) }}€
                        </div>
                        <div class="discount-percentage raleway-reg-p12" v-if="promoDiscountPercentageText != ''">
                          {{ promoDiscountPercentageText }}
                        </div>
                      </div>
                      <div class="raleway-reg-p15" v-else>{{ item.amount }} €</div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="raleway-reg-p15">{{item.format == 'physique' ? 'Physique' : 'E-Coffret' }}</div>
                      <div class="raleway-reg-p15">{{ item.format_price }} €</div>
                    </div>
                    <div v-if="isPhone" class="d-flex w-100 justify-content-end">
                      <div class="link-text raleway-medi-p13 pl-3" @click="activeUpdateModalId = item.id">Modifier</div>
                    </div>
                    <div class="d-flex justify-content-between" :class="isPhone ? '' : 'pt-3'">
                      <div class="raleway-semi-p15">Montant total</div>
                      <div class="raleway-semi-p15">{{ getItemTotalAmount(item) }} €</div>
                    </div>
                  </div>
                </div>
                <div class="border-bottom-gray ml-4 my-3" v-if="purchasesCount > 0 && index != giftBoxPurchase.gift_box_purchase_items.length - 1"></div>
              </div>
              <div class="border-bottom-black my-3" v-if="purchasesCount > 0"></div>
              <div class="total-container">
                <div class="d-flex justify-content-between">
                  <div class="raleway-reg-p15">Frais de livraison</div>
                  <div class="raleway-reg-p15">Offerts</div>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="raleway-reg-p15">Coffret physique</div>
                  <div class="raleway-reg-p15">{{ totalFormatPrice }}€</div>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="raleway-semi-p15">Montant total à payer</div>
                  <div>
                    <p class="raleway-semi-p15 mb-0">
                      {{ totalAmountToPaid.toFixed(2) }}€
                    </p>
                  </div>
                </div>
              </div>
              <p class="raleway-it-l12 ml-4 my-3">Veuillez noter que tous les bénéficiaires reçoivent un e-coffret, y compris lorsqu’un coffret physique est commandé. La carte cadeau est valable 2 ans.</p>
              <div class="d-flex flex-column delivery-note">
                <div class="d-flex align-items-center">
                  <img src="../../images/info.svg" v-set-alt/>
                  <p class="raleway-semi-p15 mb-0" :class="isPhone ? 'ml-2' : 'ml-3'">LIVRAISON</p>
                </div>
                <p class="raleway-reg-p13 pt-2">
                  Coffret physique : livraison gratuite sous 5 à 7 jours ouvrés en France métropolitaine uniquement.
                </p>
              </div>
              <div class="d-flex flex-column promo-container mt-4">
                <label for="code_promo" class="raleway-semi-p15 text-uppercase mb-0">Code exclusif</label>
                <div
                  class="d-flex align-items-center"
                  :style="{ gap: isPhone ? '14px' : '20px', height: isPhone ? '55px' : '' }"
                > 
                  <div class="position-relative col-8 col-md-8 px-0 w-100">
                    <input v-model="code_promo" type="text" class="w-100" :class="{'border-green': promoDiscountPercentageText != '' && isButtonDisabled, 'border-red': promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'}"/>
                    <i
                      v-if="promoDiscountPercentageText != '' && isButtonDisabled"
                      class="fa fa-check fa-lg text-green tick-icon"
                    ></i>
                    <i
                      v-else-if="promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'"
                      class="fa-solid fa-xmark fa-lg cross-icon" style="color: red;"
                    ></i>
                  </div>
                  <button :disabled="this.isButtonDisabled" style="display:inline;cursor:pointer;" id="code_button" class="hortense-btn-primary w-100" :class="isPhone ? 'mb-3' : ''" @click="applyCode">VALIDER</button>
                </div>
                <p v-if="promoDiscountPercentageText != '' && isButtonDisabled" class="raleway-reg-p12 text-green mb-0">*Votre code exclusif a été appliquée.</p>
                <p v-else-if="promoCodeValidity === 'false' || promoCodeValidity === 'null' || promoCodeValidity === 'notvalid'" class="raleway-reg-p12 mb-0" style="color: red">*Votre code exclusif non reconnu..</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isPhone && giftBoxPurchase.gift_box_purchase_items.length > 0" class="w-100" :class="showPurchaseItems ? 'floating-menu' : 'floating-menu-bottom'">
          <div class="d-flex justify-content-between w-100">
            <div class="raleway-semi-p15" style="letter-spacing: -0.45px;">Votre panier</div>
            <div class="d-flex align-items-center justify-content-end" style="gap: 5px;">
              <div class="raleway-semi-p15">{{ purchasesCount }} coffret<span v-if="purchasesCount > 1">s</span></div>
              <div>
                <i v-if="!showPurchaseItems" class="fa-solid fa-chevron-down text-green" @click="showPurchaseItems = true" style="width: 5px; height: 5px;"></i>
                <i v-if="showPurchaseItems" class="fa-solid fa-chevron-up text-green" @click="showPurchaseItems = false" style="width: 5px; height: 5px;"></i>
              </div>
            </div>
          </div>
          <div class="w-100" v-if="showPurchaseItems">
            <div v-for="(item, index) in giftBoxPurchase.gift_box_purchase_items" :key="item.purchase_id">
              <div class="d-flex justify-content-between align-items-start w-100">
                <div class="d-flex align-items-center" style="gap: 10px;">
                  <div class="raleway-reg-p15 text-green">{{ item.quantity }} x</div>
                  <div class="raleway-reg-p15">{{ item.name }}</div>
                </div>
                <div class="d-flex flex-column align-items-end">
                  <div class="raleway-semi-p15" v-if="promoDiscountAmount > 0">{{ getItemTotalAmount(item) }}€</div>
                  <div class="raleway-reg-p15 d-flex align-items-center" v-if="promoDiscountAmount > 0">
                    <s class="text-light-gray">{{ getItemTotalAmount(item) }}€</s>
                    <div class="discount-percentage raleway-reg-p12 ml-2" v-if="promoDiscountPercentageText != ''">
                      {{ promoDiscountPercentageText }}
                    </div>
                  </div>
                  <div class="raleway-reg-p15" v-else>{{ getItemTotalAmount(item) }}€</div>
                </div>
              </div>
            </div>
            <div class="border-bottom-gray my-2"></div>
            <div class="d-flex justify-content-between">
              <div class="raleway-semi-p15">Frais de livraison</div>
              <div class="raleway-light-p15">Offerts</div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="raleway-semi-p15">Coffret physique</div>
              <div class="raleway-reg-p15">{{ totalFormatPrice }}€</div>
            </div>
            <div class="border-bottom-black mt-2"></div>
          </div>
          <div class="d-flex justify-content-between w-100">
            <div class="raleway-semi-p15">Montant total à payer</div>
            <div class="raleway-semi-p15">
              <div class="d-flex align-items-center justify-content-end" style="gap: 5px;" v-if="promoDiscountAmount > 0 && !showPurchaseItems">
                <div class="raleway-reg-p15 mb-0 discounted-amount text-light-gray">
                  <s>{{ purchaseItemsTotal.toFixed(2) }}€</s>
                </div>
                <div class="raleway-semi-p15">
                    {{ totalAmountToPaid.toFixed(2) }}€
                </div>
                <div class="discount-percentage raleway-reg-p12" v-if="promoDiscountPercentageText != ''">
                  {{ promoDiscountPercentageText }}
                </div>
              </div>
              <div v-else>
                <p class="raleway-semi-p15 mb-0">
                  {{ totalAmountToPaid.toFixed(2) }}€
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="bookingConfirmed" class="w-100">
    <GiftBoxConfirmed :gift-box-purchase="giftBoxPurchaseWithTotals" :purchase-total="totalAmountToPaid" @close="close()" />
  </div>
</div>
</template>
<script>
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import fetcher from "packs/shared/api.js";
import GiftBoxItem from "./GiftBoxItem.vue";
import GiftBoxConfirmed from "./GiftBoxConfirmed.vue";
import ModalGiftBoxUpdate from "../../components/modals/ModalGiftBoxUpdate.vue";
export default {
  name: 'gift-box-payment',
  components: {
    VueDatePicker,
    GiftBoxItem,
    ModalGiftBoxUpdate,
    GiftBoxConfirmed
  },
  props: {
    giftBoxes: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      giftBoxItems: this.giftBoxes,
      giftBoxPurchase: {
        purchase_type: 'beneficiary',
        personal_message: '',
        scheduled_date: null,
        client_secret: null,
        payment_id: null,
        discount: 0,
        amount: 0,
        owner: {
          first_name: '',
          last_name: '',
          city: '',
          country: '',
          email: '',
          phone: '',
          address: '',
          postal_code: '',
          company_name: '',
          vat_number: '',
          stripe_customer_id: '',
        },
        receiver: {
          first_name: '',
          last_name: '',
          email: ''
        },
        gift_box_purchase_items: []
      },
      cardDetails: {
        lastFourDigits: null,
        type: null,
        expiryMonth: null,
        expiryYear: null,
        holder: null,
      },
      currentStep: 1,
      isProcessingPayment: false,
      acceptConditions: false,
      stripeKey: document.querySelector("meta[name='stripe-key']").getAttribute("content"),
      stripe: null,
      paymentIntentId: null,
      clientSecret: null,
      displayError: this.$refs.errorsCard,
      card: null,
      status: {
        createToken: null,
        createCustomer: null,
        addCard: null,
        paymentIntent: null,
        confirmCardPayment: null,
        createGiftBoxPurchase: null
      },
      code_promo: null,
      isButtonDisabled: false,
      activeUpdateModalId: null,
      activeAddModalId: null,
      promoDiscountAmount: 0,
      promoDiscountPercentageText: '',
      promoCodeValidity: '',
      bookingConfirmed: false,
      giftBoxPurchasePayload: null,
      pendingGiftBoxPurchase: null,
      discountPercentage: 0,
      showPurchaseItems: false,
      sessionId: 'gf_' + Math.random().toString(36).substr(2, 12)
    }
  },
  beforeMount(){
    this.giftBoxItems = this.giftBoxes.map(item => ({
      ...item,
      quantity: 1,
      format: 'e-coffret',
      amount: 0
    }));
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.status.createGiftBoxPurchase) {
      this.trackPendingGiftBoxPurchase()
        .finally(() => next())
    } else {
      next()
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    if (this.user) {
      const fields = [
        'first_name', 'last_name', 'city', 'country', 'email', 'phone',
        'address', 'postal_code',
        'company_name', 'vat_number', "stripe_customer_id"
      ];
      fields.forEach(field => {
        this.giftBoxPurchase.owner[field] = this.user[field] || '';
      });
    }
    this.mountStripeElements();
  },
  methods: {
    getActiveUpdateItem() {
      return this.giftBoxPurchase.gift_box_purchase_items.find(item => item.id === this.activeUpdateModalId);
    },
    getActiveAddItem() {
      return this.giftBoxItems.find(item => item.id === this.activeAddModalId);
    },
    scrollToSection(sectionId, headerOffset = 100) {
      const section = document.getElementById(sectionId);
      if (section) {
        const y = section.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    },
    close() {
      window.location.href = '/coffrets-cadeaux';
    },
    changeStep(step) {
      switch (step) {
        case 2:
          if (this.validateStep(1)) {
            this.currentStep = step;
            this.$nextTick(() => {
              this.scrollToSection('step-2');
            })
          }
          break;
        case 3:
          if (this.validateStep(2)) {
            this.currentStep = step;
            this.trackPendingGiftBoxPurchase();
            this.$nextTick(() => {
              this.scrollToSection('step-3');
            })
          }
          break;
        case 4:
          this.currentStep = step;
          this.$nextTick(() => {
            this.scrollToSection('step-4');
          })
          break;
      }
    },
    togglePurchaseType(type) {
      if (this.giftBoxPurchase.purchase_type === type) {
        this.giftBoxPurchase.purchase_type = 'beneficiary';
      } else {
        this.giftBoxPurchase.purchase_type = type;
      }
    },
    async initCreateStripeCustomer() {
      try {
        const createCustomerResponse = await fetcher.post("/create_customer", {
          card_token: this.cardToken,
          user: this.giftBoxPurchase.owner,
        });
        this.status.createCustomer = true;
        this.giftBoxPurchase.owner.stripe_customer_id = createCustomerResponse.data.stripe_customer_id;
      } catch (e) {
        this.status.createCustomer = false;
        console.error("Failed initCreateStripeCustomer", e?.response?.data || e.message);
        alert("Payment failed: Your card was declined. Please use a different card or contact your bank.");
      }
    },
    async initCreateCardToken() {
      try {
        const response = await this.stripe.createToken(this.cardNumber);
        if (response.error) {
          this.status.createToken = false;
          console.log("Failed createToken");
          console.log(response.error);
        } else {
          this.status.createToken = true;
          this.cardToken = response.token;
        }
      } catch (e) {
        this.status.createToken = false;
        console.log("Failed initCreateCardToken");
        console.log(e);
      }
    },
    async initPaymentIntent() {
      try {
        const response = await fetcher.post("/gift_box_purchases/payment_intent", {
          stripe_customer_id: this.giftBoxPurchase.owner.stripe_customer_id,
          gift_box: {
            amount: this.totalAmountToPaid,
          },
          user: this.giftBoxPurchase.owner,
        });
        this.status.paymentIntent = true;
        this.paymentIntentId = response.data.payment_intent_id;
        this.clientSecret = response.data.client_secret;
      } catch (e) {
        this.status.paymentIntent = false;
        console.log("Failed initPaymentIntent");
        console.log(e);
      }
    },
    async initConfirmCardPayment() {
      try {
        const response = await this.stripe.confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.cardNumber,
          },
        });
        if (response.error) {
          console.log("Failed confirmCardPayment");
          console.log(response.error);
          this.status.confirmCardPayment = false;
          this.displayError.textContent = response.error.message;
        } else {
          this.status.confirmCardPayment = true;
        }
      } catch (e) {
        this.status.confirmCardPayment = false;
        console.log("Failed initConfirmCardPayment");
        console.log(e);
      }
    },
    async addNewSripeCard() {
      try {
        const response = await fetcher.post("/add_card", { card_token: this.cardToken.id });
        if (response.data.error) {
          this.displayError.textContent = response.data.error;
          this.status.addCard = false;
        } else {
          this.status.addCard = true;
        }
      } catch (e) {
        this.status.addCard = false;
        console.log("Failed addNewSripeCard");
        console.error(e);
      }
    },
    hasStatusError() {
      const error = Object.values(this.status).find((el) => el === false);
      return error === false ? true : false;
    },
    async handlePayment() {
      // FROM HERE
      this.displayError.textContent = "";
      this.isProcessingPayment = true;

      await this.initCreateCardToken();

      if (!this.hasStatusError()) {
        if (!this.giftBoxPurchase.owner.stripe_customer_id) {
          await this.initCreateStripeCustomer();
        } else {
          await this.addNewSripeCard();
        }
      }

      if (!this.hasStatusError() && this.totalAmountToPaid > 0) {
        await this.initPaymentIntent();
        await this.initConfirmCardPayment();
      }
      // TO HERE
      setTimeout(() => {
        if (!this.hasStatusError()) {
          this.createGiftBoxPurchase();
        }
      }, 1000);
      this.isProcessingPayment = false;
    },
    async mountStripeElements() {
      await this.$nextTick();

      if (!document.querySelector("#card-number")) {
        console.warn("Stripe input fields not found in DOM yet");
        return;
      }

      if (!this.stripe) {
        this.stripe = Stripe(this.stripeKey);
      }

      const elements = this.stripe.elements();

      const elementStyles = {
        base: {
          color: "rgba(0, 0, 0, 0.9)",
          fontWeight: "600",
          fontSize: "12px",
          fontFamily: "Raleway, sans-serif",
          fontStyle: "normal",
          lineHeight: "18px",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: "600",
          },
          ":-webkit-autofill": {
            color: "rgba(0, 0, 0, 0.5)",
          },
        },
        invalid: {
          color: "#E25950",
          "::placeholder": {
            color: "#FFCCA5",
          },
        },
      };

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid",
      };

      this.cardNumber = elements.create("cardNumber", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardNumber.mount("#card-number");

      this.cardExpiry = elements.create("cardExpiry", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardExpiry.mount("#card-expiry");

      this.cardCvc = elements.create("cardCvc", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardCvc.mount("#card-cvc");

      this.displayError = this.$refs.errorsCard;
    },
    async createGiftBoxPurchase() {
      try {
        // Calculate total_amount for each item before sending
        const itemsWithTotals = this.giftBoxPurchase.gift_box_purchase_items.map(item => ({
          ...item,
          total_amount: this.getItemTotalAmount(item)
        }));

        const res = await fetcher.post("/gift_box_purchases", {
          gift_box_purchase: {
            ...this.giftBoxPurchase,
            gift_box_purchase_items: itemsWithTotals,
            amount: this.totalAmountToPaid,
            session_id: this.sessionId,
            discount: this.promoDiscountAmount,
            payment_id: this.paymentIntentId,
            client_secret: this.clientSecret,
            promo_code: this.code_promo,
            status: 'completed'
          }
        });
        this.giftBoxPurchasePayload = res.data;
        this.status.createGiftBoxPurchase = true;
        this.bookingConfirmed = true;
        
      } catch (e) {
        this.status.createGiftBoxPurchase = false;
        console.log("Failed create gift box purchase");
        console.error(e);
      }
    },
    async trackPendingGiftBoxPurchase(){
      if (!(this.validateStep(1) && this.validateStep(2))) {
       return;
      }
      try {
        // Calculate total_amount for each item before sending
        const itemsWithTotals = this.giftBoxPurchase.gift_box_purchase_items.map(item => ({
          ...item,
          total_amount: this.getItemTotalAmount(item)
        }));

        const res = await fetcher.post("/gift_box_purchases", {
          gift_box_purchase: {
            ...this.giftBoxPurchase,
            gift_box_purchase_items: itemsWithTotals,
            amount: this.totalAmountToPaid,
            session_id: this.sessionId,
            discount: this.promoDiscountAmount,
            payment_id: this.paymentIntentId,
            client_secret: this.clientSecret,
            promo_code: this.code_promo,
            status: 'pending'
          }
        });
        this.pendingGiftBoxPurchase = res.data;
        
      } catch (e) {
        console.log("Failed to create pending gift box purchase");
        console.error(e);
      }
    },
    resetGiftBoxState(giftbox) {
      giftbox.quantity = 1;
      giftbox.amount = 0;
      giftbox.format = 'e-coffret';
      giftbox.format_price = 0;
    },
    addToCart(giftbox) {
      if (giftbox.quantity > 0 && giftbox.amount > 0) {
        this.giftBoxPurchase.gift_box_purchase_items.push({ ...giftbox, purchase_id: Math.random() });
      }
      this.activeAddModalId = null;
      this.resetGiftBoxState(giftbox);
    },
    removeFromCart(id) {
      const index = this.giftBoxPurchase.gift_box_purchase_items.findIndex(item => item.purchase_id === id);
      if (index !== -1) {
        this.giftBoxPurchase.gift_box_purchase_items.splice(index, 1);
      }
      this.activeAddModalId = null;
    },
    updateCartItem(item) {
      const index = this.giftBoxPurchase.gift_box_purchase_items.findIndex(i => i.purchase_id === item.purchase_id);
      if (index !== -1) {
        this.$set(this.giftBoxPurchase.gift_box_purchase_items, index, item);
      }
      this.activeUpdateModalId = null;
    },
    scroll_left() {
      let content = document.querySelector("#scroller");
      content.scrollLeft -= 150;
    },
    scroll_right() {
      let content = document.querySelector("#scroller");
      content.scrollLeft += 150;
    },
    validateStep(step) {
      if (step === 1) {
        return this.giftBoxPurchase.gift_box_purchase_items?.length > 0;
      }

      if (step === 2) {
        const { purchase_type, owner, receiver } = this.giftBoxPurchase;

        const requiredFields = {
          personal: ['owner.first_name', 'owner.last_name', 'owner.email', 'owner.address', 'owner.postal_code', 'owner.city', 'owner.country'],
          beneficiary: [
            'owner.first_name', 'owner.last_name', 'owner.email',
            'receiver.first_name', 'receiver.last_name', 'receiver.email'
          ],
          entreprise: [
            'owner.company_name', 'owner.vat_number', 'owner.first_name', 'owner.last_name',
            'owner.phone', 'owner.email', 'owner.address',
            'owner.postal_code', 'owner.city', 'owner.country'
          ],
        };

        const fieldsToCheck = requiredFields[purchase_type] || [];

        return fieldsToCheck.every(path => {
          const value = path.split('.').reduce((acc, key) => acc?.[key], this.giftBoxPurchase);
          return !!value?.toString().trim();
        });
      }

      return true;
    },
    resetDiscountState() {
      this.promoDiscountAmount = 0;
      this.promoDiscountPercentageText = '';
      this.isButtonDisabled = false;
      this.promoCodeValidity = '';
      this.discountPercentage = 0;
    },
    async applyCode() {
      try {
        const today = new Date();
        today.setDate(today.getDate() + 1);
        const response = await fetcher.get('/user_codes/' + this.code_promo);
        const codeData = response.data;

        if (this.promoDiscountAmount > 0 && codeData && this.code_promo.trim() !== '') {
          this.resetDiscountState();
        }

        if (
          codeData.code_status === true &&
          today <= new Date(codeData.expiry_date) &&
          today >= new Date(codeData.validity_date) &&
          !codeData.code_utilization_date
        ) {
          if (codeData.code_type === 7) {
            const discountPercentage = parseInt(codeData.code_type_description);
            const discount = (this.totalWithoutAddOns * discountPercentage) / 100;
            this.discountPercentage = discountPercentage;
            this.promoDiscountAmount = discount;
            this.isButtonDisabled = true;
            this.promoDiscountPercentageText = `-${discountPercentage}%`;
            this.promoCodeValidity = null;
          } else {
            this.promoCodeValidity = 'notvalid';
          }
        } else {
          this.promoCodeValidity = 'false';
        }
      } catch (e) {
        this.promoCodeValidity = 'null';
        console.error(e);
      }
    },
    handleBeforeUnload() {
      if (!this.status.createGiftBoxPurchase) {
        this.trackPendingGiftBoxPurchase();
      }
    },
    getPercentageAmount(amount, percentage) {
      return (amount * percentage) / 100;
    },
    getItemTotalAmount(item) {
      let total = (item.amount + item.format_price) * item.quantity;
      if (this.discountPercentage > 0) {
        total = total - (this.getPercentageAmount(item.amount, this.discountPercentage) * item.quantity);
      }
      return total;
    },
    handleCalendarIconClick() {
      this.$nextTick(() => {
        const calendarInput = this.$el.querySelector('.vd-picker__input');
        if (calendarInput) {
          calendarInput.click();
        }
      });
    },
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    purchasesCount() {
      return this.giftBoxPurchase.gift_box_purchase_items && this.giftBoxPurchase.gift_box_purchase_items.length > 0
        ? this.giftBoxPurchase.gift_box_purchase_items.reduce((total, item) => total + parseInt(item.quantity), 0)
        : 0;
    },
    purchaseItemsTotal() {
      return this.giftBoxPurchase.gift_box_purchase_items && this.giftBoxPurchase.gift_box_purchase_items.length > 0
        ? this.giftBoxPurchase.gift_box_purchase_items.reduce((total, item) => total + this.getItemTotalAmount(item), 0)
        : 0;
    },
    totalWithoutAddOns() {
      return this.giftBoxPurchase.gift_box_purchase_items && this.giftBoxPurchase.gift_box_purchase_items.length > 0
        ? this.giftBoxPurchase.gift_box_purchase_items.reduce((total, item) => total + (item.amount * item.quantity), 0)
        : 0;
    },
    totalAmountToPaid() {
      return this.purchaseItemsTotal;
    },
    totalFormatPrice() {
      return this.giftBoxPurchase.gift_box_purchase_items && this.giftBoxPurchase.gift_box_purchase_items.length > 0
        ? this.giftBoxPurchase.gift_box_purchase_items.reduce((total, item) => total + (item.format_price * item.quantity), 0)
        : 0;
    },
    customDeliveryDateItem() {
      const item = this.giftBoxPurchase.gift_box_purchase_items.find(item => item.format == 'physique' && item.send_date && item.send_date !== '');
      if (item) {
        return {name: item.name, send_date: new Date(item.send_date).toLocaleDateString('fr-FR').replace(/\//g, '-')};
      }
      return null;
    },
    giftBoxPurchaseWithTotals() {
      const itemsWithTotals = this.giftBoxPurchase.gift_box_purchase_items.map(item => ({
        ...item,
        total_amount: this.getItemTotalAmount(item)
      }));
      
      return {
        ...this.giftBoxPurchase,
        gift_box_purchase_items: itemsWithTotals
      };
    }
  },
  watch: {
    code_promo() {
      if (
        this.code_promo === ''
      ) {
        this.resetDiscountState();
      }
    },
    currentStep(newStep) {
      if (newStep === 4) {
        this.mountStripeElements();
      }
    },
    cardToken() {
      this.cardDetails.lastFourDigits = this.cardToken.card.last4;
      this.cardDetails.type = this.cardToken.card.brand;
      this.cardDetails.expiryMonth = this.cardToken.card.exp_month;
      this.cardDetails.expiryYear = this.cardToken.card.exp_year;
    },
    'giftBoxPurchase.gift_box_purchase_items': {
      handler(newItems) {
        newItems.forEach(item => {
          item.gift_box_id = item.id;
          item.format_price = item.format === 'physique' ? item.free_physique ? 0 : 29 : 0;
        });
        if (newItems.length == 0) {
          this.code_promo = '';
        }
        console.log('giftBoxPurchase', this.giftBoxPurchase);
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
#gift-box-payment {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .back-button {
    width: 40px;
    height: 38px;
    border-radius: 5px;
    background: #00000029;

    img {
      width: 23px;
      margin-left: 8px;
    }
  }

  .link-hortense {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
  }

  .text-underline {
    text-decoration: underline;
    cursor: pointer;
  }

  .container-gift-box {
    width: 93%;

    .card-checkout-items {
      background-color: #F7F7F7;
      display: flex;
      flex-direction: column;
      align-items: start;
      min-height: 529px;
      max-height: 100%;
      overflow: auto;
      padding: 26px 22px 26px 22px;
      position: sticky;
      top: 5%;
    }
  }

  .information-section {
    .line-form {
      label {
        display: flex;
        flex-direction: column;
        font-family: $Raleway;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
        line-height: 18px;
      }
      input[type="text"] {
        border: 1px solid rgba(0, 0, 0, 0.5);
        padding: 16px;
        gap: 10px;
        height: 56px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        margin-top: 8px;

        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
          width: 100%;
        }

        &:focus {
          outline: none;
        }
      }
    }
  }

  .personalise-section {
    .form-text-area {
      width: 100%;
      height: 113px;
      border-radius: 13px;
      border: 1px solid rgba(59, 97, 82, 1);
      padding: 13px;
      font-family: $Raleway;
      font-weight: 500;
      font-size: 12px;
      &:focus {
        outline: none;
      }
    }
    textarea::placeholder {
      color: rgba(128, 128, 128, 1);
      font-family: $Raleway;
      font-weight: 300;
      font-size: 15px;
    }

    .date-picker-container {
      background: rgba(247, 247, 247, 1) 0% 0% no-repeat padding-box;
      height: 47px;
      width: 414px;
      .calendar-container {
        position: relative;
        display: inline-block;
        width: 176px;
      }

      .calendar-input {
        border: none;
        padding-left: 55px; /* leave space for icon */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: white;
      }

      .calendar-input::-webkit-calendar-picker-indicator {
        opacity: 0;
        cursor: pointer;
        z-index: 2;
        position: absolute;
        right: 0;
      }

      .calendar-icon {
        position: absolute;
        top: 50%;
        left: 0.75rem;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
        background-image: url('../../images/icon_calendar.svg');
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 1;
      }
    }
  }

  .payment-section {
    #card-errors {
      color: red;
    }

    .card-stripe {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #F7F7F7;
      padding: 32px 24px;
      gap: 4px;
    }

    .card-stripe .field {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
      gap: 10px;
      width: 346px;
      height: 50px;
      border: 1px solid rgba(0, 0, 0, 0.5);
      border-radius: 8px;

      input {
        font-family: $Raleway;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
      }

      input::placeholder {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .payment-icons {
      gap: 10px;
    }

    .card-stripe .field.half-width {
      width: 47%;
    }

    .card-stripe .field.quarter-width {
      width: calc(25% - 10px);
    }

    .card-stripe .baseline {
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: #cfd7df;
      transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .card-stripe .input {
      width: 100%;
      color: #32325d;
      background-color: transparent;
    }

    .card-stripe input[type="text"] {
      appearance: none;
      outline: none;
      border-style: none;
      width: 100%;
      height: 100%;
      background-color: transparent;
    }
  }

  .empty-cart {
    height: 529px;
  }

  .total-container {
    padding-left: 2.5rem;

    @media screen and (max-width: 768px) {
      padding-left: 1.5rem;
    }
  }

  .delivery-note {
    height: 117px;
    background: #A5D3AE48 0% 0% no-repeat padding-box;
    border-radius: 7px 7px 0px 7px;
    opacity: 1;
    padding: 22px 29px 20px 42px;
  }

  .promo-container {
    input[type="text"] {
      height: 48px;
      border: 1px solid #707070;
      border-radius: 4px;
      padding: 7px;
      padding-left: 14px;

      &:focus {
        outline: none;
      }
    }

    .tick-icon {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    .cross-icon {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  text-light-gray {
    color: rgba(0, 0, 0, 1);
    opacity: 0.42;
  }

  .discount-percentage {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px;
    gap: 10px;
    width: 32px;
    height: 18px;
    background: rgba(165, 211, 174, 0.47);
    border-radius: 2px;
  }

  .border-green {
    border-color: #3B6152 !important;
    color: #3B6152;
  }

  .border-red {
    border-color: red !important;
    color: red;
  }
}

.gift-box-payment-phone {
  width: 100% !important;
  padding-top: 30%;

  .back-button {
    width: 36px !important;
    height: 38px !important;

    img {
      margin-left: 0 !important;
      width: 20px !important;
    }
  }

  .card-checkout-items {
    min-height: 327px !important;
    max-height: 852px !important;
    .empty-cart {
      height: 327px !important;
    }
  }

  .delivery-note {
    padding: 16px !important;
  }

  .promo-container {
    input[type="text"] {
      height: 42px !important;
    }

    .hortense-btn-primary {
      height: 42px !important;
      width: 123px !important;
    }
  }

  .card-gift-box-item {
    .gift-box-img {
      width: 181px;
      height: 163px;

      img {
        width: 181px;
        height: 163px;
        object-fit: fill;
      }
    }
    .hortense-btn-primary {
      width: 181px !important;
      height: 42px !important;
      white-space: nowrap;
    }
  }

  .previous-slide-button {
    position: absolute;
    top: 47%;
    transform: translateY(-50%);
    left: 11px;
    color: #000000;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .next-slide-button {
    position: absolute;
    top: 47%;
    transform: translateY(-50%);
    right: 11px;
    color: #000000;
    
    img {
      width: 20px;
      height: 20px;
    }
  }

  .circle-icon {
    width: 35px;
    height: 35px;
    border: 1px solid #F5F5F5;
		background: #F5F5F5 0% 0% no-repeat padding-box;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

}

.border-bottom-gray {
  border-bottom: 0.5px solid #707070;
}

.border-bottom-black {
  border-bottom: 1px solid #000000;
}

.light-gray-text {
  color: rgba(0, 0, 0, 1);
}

.link-hortense {
  color: rgba(59, 97, 82, 1);
}
.text-green {
  color: #3B6152;
}
.link-text {
  color: #3B6152;
  text-decoration: underline;
  cursor: pointer;
}

.hortense-btn-primary {
  cursor: pointer;
}

.nav-phone {
  .logo {
    z-index: 1 !important;
  }
}

.floating-menu {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: auto;
  background: #F7F7F7;
  box-shadow: 3px 0px 6px #00000029;
  padding: 9px 23px 15px 23px;
}

.floating-menu-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: auto;
  background: #F7F7F7;
  box-shadow: 3px 0px 6px #00000029;
  padding: 9px 23px 15px 23px;
}
</style>